import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ReduxSlices} from "floorplan-v2/app/appRoot/types";
import { IFloorplanFilterSlice } from 'floorplan-v2/app/reducers/floorplanFilter/types';
import {IServiceItem, IServiceListView} from "shared-types/index";
import {FloorplanV2State} from "floorplan-v2/app/appRoot/rootReducer";
import DateUtilsService from "external-services/date-utils-service";

// Note: The Diary Header calls most of these actions - mainly for floorplan view
const NS = 'FloorplanFilterSlice';

const initialState: IFloorplanFilterSlice = {
  selectedFloorplanTime: null,
  previousSelectedFloorplanTime: null,
  targetService: null,
  isTimeNow: true,
  showPastMessageBanner: false
};

export const setTargetService = createAsyncThunk(
  `${ReduxSlices.FloorplanFilter}/setTargetService`,
  async (payload: {
    serviceViews: IServiceListView[],
    selectedServiceView: IServiceListView
  }, { dispatch, getState }): Promise<IServiceItem> => {
    const {selectedServiceView, serviceViews} = payload;

    if (selectedServiceView) {
      return (selectedServiceView.service || selectedServiceView.services[0]) as IServiceItem
    }

    if (!serviceViews?.length) {
      return null;
    }

    const {
      floorplanFilterReducer: {selectedFloorplanTime}
    } = getState() as FloorplanV2State;

    const targetServices: IServiceItem[] = serviceViews.reduce((acc: IServiceItem[], sv: IServiceListView) => {
      if (sv.service) {
        const service: IServiceItem = sv.service as IServiceItem;
        const startTime = new Date(service.startTime);
        const endTime = new Date(service.endTime);
        const isWithinTimes = DateUtilsService.isOnOrInBetweenDates(selectedFloorplanTime, startTime, endTime);
        if (isWithinTimes) {
          acc.push(service);
        }
      } else if (sv.services?.length) {
        const firstServiceWithinTimes = sv.services.find(service => {
          const startTime = new Date(service.startTime);
          const endTime = new Date(service.endTime);
          const isWithinTimes = DateUtilsService.isOnOrInBetweenDates(selectedFloorplanTime, startTime, endTime);
          return isWithinTimes ? service : null;
        });
        if (firstServiceWithinTimes) {
          acc.push(firstServiceWithinTimes)
        }
      }

      return acc;
    }, [] as IServiceItem[]);

    return targetServices.length ? targetServices[0] : null;
  }
);


const floorplanFilterSlice = createSlice({
  name: ReduxSlices.FloorplanFilter,
  initialState,
  reducers: {
    setSelectedFloorplanTime: (state, action: PayloadAction<Date>) => {
      state.selectedFloorplanTime = action.payload;
    },
    setPreviousSelectedFloorplanTime: (state, action: PayloadAction<Date>) => {
      state.previousSelectedFloorplanTime = action.payload;
    },
    setIsTimeNow: (state, action: PayloadAction<boolean>) => {
      state.isTimeNow = action.payload;
    },
    setShowPastMessageBanner: (state, action: PayloadAction<boolean>) => {
      state.showPastMessageBanner = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setTargetService.fulfilled, (state, action) => {

      console.log(NS, '---- targetService', action.payload);
      state.targetService = action.payload;
    });
  },
});

const actions = floorplanFilterSlice.actions;
export { actions as floorplanFilterActions };

export default floorplanFilterSlice.reducer;
